
export class ApiManager {
  static async fetchWithAbort(url: string, options?: RequestInit): Promise<Response> {
    try {
      const response = await fetch(url, options);

      // Global Token Expiration Check
      if (response.status === 401 || response.status === 403) {
        console.warn('Session expired. Redirecting to login...');
        
        // Clear all storage
        localStorage.clear();
        sessionStorage.clear();

        // Redirect only if not already on public pages
        const publicPaths = ['/login', '/otp-verify', '/', '/onboard'];
        const currentPath = window.location.pathname;
        
        if (!publicPaths.includes(currentPath)) {
             window.location.href = '/login';
        }
      }

      return response;
    } catch (error) {
      console.error('API Fetch Error:', error);
      throw error;
    }
  }

  // Helper method for authenticated requests (if headers needed in future)
  static async fetch(url: string, options?: RequestInit): Promise<Response> {
      return this.fetchWithAbort(url, options);
  }
}
